// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__-oV8v","categories__body":"Categories_categories__body__Ah1-h","categories__body1":"Categories_categories__body1__16Vgy"};